<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{'parameters.originSelector.title.shortLabel' | translate}}
                <app-tooltip text="{{'parameters.originSelector.title.summary' | translate}}"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form *ngIf="!isLoading && options && options.length" [formGroup]="originForm" (submit)="onSubmit()" class="origin-form">
            <mat-form-field class="origin-field">
                <input type="text" matInput formControlName="origin"
                    onclick="this.select()"
                    [matAutocomplete]="auto">
                <mat-label class="placeholder">{{'parameters.originSelector.form.origin.shortLabel' | translate}}</mat-label>
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                        {{option.text.fullLabel}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <button *ngIf="!isLoading" type="submit" mat-raised-button color="accent" [disabled]="originForm.invalid">
                {{'parameters.originSelector.form.submit.shortLabel' | translate}}
            </button>
        </form>
        <div *ngIf="isLoading" class="spinner-container">
            <mat-spinner [diameter]="35" color="accent" class="spinner"></mat-spinner>
        </div>
    </mat-card-content>
</mat-card>
